import { render, staticRenderFns } from "./notDate.vue?vue&type=template&id=38a9345c&scoped=true&"
var script = {}
import style0 from "./notDate.vue?vue&type=style&index=0&id=38a9345c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a9345c",
  null
  
)

export default component.exports